(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    class ToyFizzStickyHeader extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.section-header');
        if (!this.section) return;

        this.alwaysSticky =
          this.dataset.stickyType === 'always' ||
          this.dataset.stickyType === 'reduce-logo-size';

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.headerBounds = {};

        this.setHeaderHeight = this.setHeaderHeight.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.preventRevealHandler = () => {
          this.preventReveal = true;
        };

        this.setHeaderHeight();

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.setHeaderHeight);
          this.resizeObserver.observe(this.section);
        }

        if (this.alwaysSticky) {
          this.section.classList.add('shopify-section-header-sticky');
        }

        this.addEventListener('preventHeaderReveal', this.preventRevealHandler);
        window.addEventListener('scroll', this.onScroll, { passive: true });

        this.createObserver();
      }

      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.preventRevealHandler);
        window.removeEventListener('scroll', this.onScroll);
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      setHeaderHeight() {
        document.documentElement.style.setProperty(
          '--header-height',
          `${this.section.offsetHeight}px`
        );
      }

      createObserver() {
        const observer = new IntersectionObserver((entries) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });

        observer.observe(this.section);
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.section.classList.add('scrolled-past-header');

          if (!this.alwaysSticky) {
            this.section.classList.add(
              'shopify-section-header-hidden',
              'shopify-section-header-sticky'
            );
            this.closeOpenMenus();
          }
        } else if (
          scrollTop < this.currentScrollTop &&
          scrollTop > this.headerBounds.bottom
        ) {
          this.section.classList.add('scrolled-past-header');

          if (!this.alwaysSticky && !this.preventReveal) {
            this.section.classList.add('shopify-section-header-sticky', 'animate');
            this.section.classList.remove('shopify-section-header-hidden');
          } else if (!this.alwaysSticky) {
            window.clearTimeout(this.scrollTimer);
            this.scrollTimer = window.setTimeout(() => {
              this.preventReveal = false;
            }, 66);
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.section.classList.remove(
            'scrolled-past-header',
            'shopify-section-header-hidden',
            'shopify-section-header-sticky',
            'animate'
          );

          if (this.alwaysSticky) {
            this.section.classList.add('shopify-section-header-sticky');
          }
        }

        this.currentScrollTop = scrollTop;
      }

      closeOpenMenus() {
        this.querySelectorAll('details[open]').forEach((details) => {
          details.removeAttribute('open');
        });
      }
    }

    if (!customElements.get('sticky-header')) {
      customElements.define('sticky-header', ToyFizzStickyHeader);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
